import {NgxUiLoaderConfig} from 'ngx-ui-loader/lib/utils/interfaces';

export namespace Loader {
	export const GLOBAL_LOADER_ID = 'GLOBAL_LOADER' as const;
	export type NgxUiLoaderConfigExtended = NgxUiLoaderConfig & {
		loaderID?: string;
		styleClass: string;
		// TEXT:
		textFontSize?: string;
		textColor?: string;

		// LOGO:
		logoWidth?: string;
		logoHeight?: string;
		logoFilter?: string;
	};

	export const DefaultConfig: NgxUiLoaderConfigExtended = {
		// Overlay
		overlayBorderRadius: '0',
		fastFadeOut: true,
		blur: 2,

		// Logo
		logoUrl: 'assets/images/logo/logo-only.png',
		logoPosition: 'center-center',
		logoSize: 120,
		logoFilter: 'invert(1)',

		//Progress Bar
		hasProgressBar: true,
		textPosition: 'bottom-center',
		pbThickness: 5,
		pbColor: 'var(--dc-primary)',

		// Background Spinner (bgs)
		bgsColor: '#0c1aa9',
		bgsPosition: 'bottom-right',
		bgsSize: 150,
		bgsType: 'three-bounce',
		//maxTime: 3000, // max time in milliseconds to wait for loading

		// Foreground Spinner (fgs)
		fgsColor: 'var(--dc-info-lighten)',
		fgsPosition: 'bottom-center',
		fgsSize: 50,
		fgsType: 'ball-spin-clockwise',

		styleClass: 'text-5xl',

		masterLoaderId: GLOBAL_LOADER_ID,

		// TEXT:
		textFontSize: '1.5rem',
		textColor: 'var(--dc-primary)',
	} as const;
}
